export default __webpack_public_path__ + "assets/images/magnum-147fd4127a36d02d778d351ba89f06a0.png";